import { z } from 'zod';

import { BankruptcyId, LosId } from '../../BrandedIds';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableBankruptcy = z
  .object({
    id: BankruptcyId,
    loanId: LosId,

    chapter: z.enum(['CHAPTER_7', 'CHAPTER_11', 'CHAPTER_12', 'CHAPTER_13']),
    filedAt: zodTemporalPlainDate,
    endDate: zodTemporalPlainDate.optional(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Bankruptcy' });

export type ExportableBankruptcy = z.infer<typeof ExportableBankruptcy>;
